<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
    <div class="row">
        <div class="col-sm" style="height: 10px;"></div>
        <div class="col-md" style="height: 20px"></div>
    </div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb" class="bread-styles">
                    <ol class="breadcrumb bd-background">
                        <li class="breadcrumb-item active" aria-current="page">
                            <a routerLink="dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a> &nbsp;
                            <span style="color: #6c757d;text-decoration: none;">Manage Leads > <a
                                    style="color: #337ab7;font-family: 'pt_sans_captionbold';"> Lead Bulk
                                    Uploads</a></span>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 20px"></div>
        </div>


    </div>
    <div class="pie-charts" style="background: white;">
        <h4 style="text-align: center;"> LEADS BULK UPLOAD </h4>
        <hr>



        <div class="container">
            <div class="file-download">
                <a download="Leads.csv" target="_blank" href="assets/leads.csv"><button type="submit"
                        class="btn btn-theme" style="background: #ed6624;color:#FFF;margin-left: 5px;">
                        <img src="assets/images/download.png">&nbsp;Download Sample File</button>
                </a>
            </div>
            <br><br>
            <form [formGroup]="form" (ngSubmit)="submit()" class="form-styles">
            
                <div class="form-group" style="padding: 10px;border: 1px solid #ced4da;">
                    <label for="file">Choose File</label> &nbsp;
                    <input type="file" accept=".csv" (change)="fileProgress($event)" class="form-control"
                        formControlName="chooseFile">
                </div>
                <div *ngIf="file_name_restrict_new">
                <div *ngIf="form.controls.chooseFile.status == 'INVALID' && (form.controls.chooseFile.dirty || form.controls.chooseFile.touched)"
                    class="alert alert-danger">
                    <div *ngIf="file_name_restrict_new">
                        Rename File --> File Name Shouldn't contain any brackets "()" <br>
                        Ex: test.svg
                    </div>
                </div>
            </div>
                <div>
                    <button class="btn btn-styles" type="submit" [disabled]="!form.valid">Upload</button>
                </div>
            </form>
            <br><br>
        </div>
    </div>
    <div class="container-fluid" *ngIf="resData">
        <div class="row">
            <div class="col-md-12">
                <br>
                <table id="exportable" border="1" cellpadding=15 class="table table-striped table-bordered">
                    <thead style="background: #19506e;color: #fff;">
                        <tr>
                            <th rowspan="2" style="text-align: center;">S.NO</th>
                            <th colspan="2" style="text-align: center;">Already Lead</th>
                            <th colspan="2" style="text-align: center;">Already Citizen Member</th>
                            <th colspan="2" style="text-align: center;">Missing Data</th>
                            <!-- <th colspan="2" style="text-align: center;">Blank</th> -->
                            <th colspan="3" style="text-align: center;">Inserted DataForm</th>

                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Name</th>
                            <th><span style="color: red;">Missing Value</span></th>
                            <!-- <th>Name</th>
                            <th>Email</th> -->
                            <th>Name</th>
                            <th>Email</th>
                            <th></th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let a of datat; let i=index">
                            <td>{{i + 1}}</td>
                            <td> {{a.aleName}} </td>
                            <td>{{a.aleEmail}} </td>
                            <td>{{a.aelName}} </td>
                            <td>{{a.aelEmail}} </td>
                            <td>{{a.mdName}} </td>
                            <td>{{a.type}} </td>
                            <!-- <td>{{a.instName}} </td>
                            <td>{{a.instEmail}} </td> -->
                            <td style="color: #28a745;font-weight: bold;">{{a.instName}} </td>
                            <td style="color: #28a745;font-weight: bold;">{{a.instEmail}} </td>
                            <td *ngIf='a.yes ==1'> <a>
                                    <button type="button" class="btn btn-warning"
                                        (click)="insertedData(a.instName,a.instEmail)">Click </button>
                                </a> </td>

                            <td *ngIf='a.yes != 1'> <a>
                                    <button disabled type="button" class="btn btn-warning"
                                        (click)="insertedData(null,null)">Click </button>
                                </a> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white">Loading </p>
    </ngx-spinner>
</section>